import script from "./EditBio.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBio.vue?vue&type=script&setup=true&lang=js"

import "./EditBio.vue?vue&type=style&index=0&id=6d6ee120&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d6ee120"]])

export default __exports__